import { Grid, IconButton, Tooltip } from "@material-ui/core";
import { ArrowDownward, ArrowUpward } from "@material-ui/icons";
import React from "react";
import { useStoreon } from "storeon/react";
import { EntityEvents, EntityState } from "@store/entity-module";

interface Props {
    atTypeId: number;
    valueKey: string;
    itemIndex: number;
    itemsLength: number;
}

const EntityAttributeValueSorting = ({ atTypeId, valueKey, itemIndex, itemsLength }: Props) => {
    const { dispatch } = useStoreon<EntityState, EntityEvents>();

    const handleSwapItem = (position: "up" | "down") => {
        dispatch("entity/attr/swap/value", {
            at_id: atTypeId,
            valueKey,
            pos: position,
        });
    };

    return (
        <Grid item>
            <Tooltip title="Переместить вверх" arrow>
                <span>
                    <IconButton
                        size="small"
                        disabled={itemIndex === 0}
                        onClick={() => handleSwapItem("up")}
                    >
                        <ArrowUpward />
                    </IconButton>
                </span>
            </Tooltip>
            <Tooltip title="Переместить вниз" arrow>
                <span>
                    <IconButton
                        size="small"
                        disabled={itemsLength - 1 === itemIndex}
                        onClick={() => handleSwapItem("down")}
                    >
                        <ArrowDownward />
                    </IconButton>
                </span>
            </Tooltip>
        </Grid>
    );
};

export default EntityAttributeValueSorting;
